import styled from 'styled-components';

const Wrapper = styled.div`
  font-size: ${props => props.theme.SMALL};
  font-weight: ${props => props.theme.SEMI_BOLD};
`;

export { Wrapper };
